import { BBDTag, Texto } from '@gravitate-js/excalibrr'
import { UpdatedTag } from '@components/Freight/shared/UpdatedTag'
import type { PointToPoint } from '@api/useFreight/types'
import type { ICellRendererParams } from 'ag-grid-community'
import dayjs from 'dayjs'
import * as React from 'react'
import { formatDate } from '../utils'

/**
 * Renders a product group with tag
 */
export function ProductGroupRenderer({ value }: { value: string }) {
  return value ? <BBDTag theme2>{value}</BBDTag> : <Texto appearance='hint'>Any</Texto>
}

/**
 * Renders a unit with tag
 */
export function UnitRenderer({ value }: { value: string }) {
  return <BBDTag theme2>{value}</BBDTag>
}

/**
 * Renders the use surcharge value
 */
export function UseSurchargeRenderer({ value }: { value: boolean }) {
  return value ? 'Yes' : 'No'
}

/**
 * Renders the updated information with a tag
 */
export function UpdatedRenderer({ data: rowData }: ICellRendererParams<PointToPoint>) {
  if (!rowData) return null

  return (
    <UpdatedTag
      updated={{
        by: rowData.updated_by || 'System',
        date: dayjs.utc(rowData.updated_on).local().format(),
      }}
      title='Table Updated'
    />
  )
}

/**
 * Renders the effective from date
 */
export function EffectiveFromRenderer({ value }: { value: string | Date }) {
  return value ? <Texto>{formatDate(value)}</Texto> : <Texto appearance='hint'>N/A</Texto>
}

/**
 * Renders the effective to date
 */
export function EffectiveToRenderer({ value }: { value: string | Date }) {
  return value ? <Texto>{formatDate(value)}</Texto> : <Texto appearance='hint'>Indefinite</Texto>
}

/**
 * Renders the next rate date
 */
export function NextRateRenderer({ value }: { value: string | Date }) {
  return value ? <Texto>{formatDate(value)}</Texto> : <Texto appearance='hint'>N/A</Texto>
}
